import { render, staticRenderFns } from "./InsuranceInformation.vue?vue&type=template&id=1dd2ac80&scoped=true"
import script from "./InsuranceInformation.vue?vue&type=script&lang=js"
export * from "./InsuranceInformation.vue?vue&type=script&lang=js"
import style0 from "./InsuranceInformation.vue?vue&type=style&index=0&id=1dd2ac80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2ac80",
  null
  
)

export default component.exports